import { render, staticRenderFns } from "./SsoRedirect.vue?vue&type=template&id=784a7da1"
import script from "./SsoRedirect.vue?vue&type=script&lang=js"
export * from "./SsoRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports